// extracted by mini-css-extract-plugin
export default {"content":"DetailsPages_content__AIIOu","content_recommendations":"DetailsPages_content_recommendations__CT8Le"};